import { render, staticRenderFns } from "./DockingStationsMapItem.vue?vue&type=template&id=3b602d3a&lang=pug&"
import script from "./DockingStationsMapItem.vue?vue&type=script&lang=js&"
export * from "./DockingStationsMapItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports